<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-row>
      <b-col md="auto" class="d-flex flex-column justify-content-center mr-3 mb-3">
          <b-avatar :src="avatarDataUrl" class="m-auto" size="6.5rem" button @click="onAvatarClick">
            <default-avatar v-if="!avatarDataUrl" style="font-size:5.5rem" />
          </b-avatar>
          <input ref="avatarUpload" type="file" name="avatar" accept="image/*" @change="onAvatarSelect" hidden />
          <b-button variant="link" class="btn-link-primary" @click="onAvatarClick">
            <b-icon-info-circle /> Add a photo
          </b-button>
      </b-col>
      <b-col>
        <b-form-group label-for="input-nickname">
          <template #label>
            How do I prefer to be called*
          </template>
          <b-form-input id="input-nickname" v-model="form.nickname" :state="isValidField('nickname')" placeholder="eg., Ericka" class="rounded-pill" />
          <b-form-invalid-feedback :state="isValidField('nickname')">
            <div v-for="error in errors.nickname || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-pronoun">
          <template #label>
            Pronouns I use*
          </template>
          <b-form-select id="input-pronoun" v-model="form.pronoun" :state="isValidField('pronoun')" placeholder="Select pronoun..." class="rounded-pill">
            <b-form-select-option
              v-for="option in pronounOptions"
              :key="option.value"
              :value="option.value">
              {{option.text}}
            </b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback :state="isValidField('pronoun')">
            <div v-for="error in errors.pronoun || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label-for="input-facts" class="mt-4">
      <template #label>
        <div>Facts about me</div>
      </template>
      <div class="mb-2">Introduce yourself to your team with a few facts about you</div>
      <b-form-textarea
        id="input-facts"
        v-model="form.facts"
        rows="4"
        placeholder="e.g: I want to be a leader who inspires my colleagues and..."
        class="rounded-xl"
      />
    </b-form-group>
    <b-form-row class="mt-5">
      <b-col>You can also do this later if you want</b-col>
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Next</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import { BIconInfoCircle } from 'bootstrap-vue'
import MixinForm from '../MixinForm'
import DefaultAvatar from '@/assets/images/avatar.svg'
import { PronounOptions, readFile } from '@/helpers/helpers'
import { PRONOUN_TYPE } from '@/helpers/types'

export default {
  name: 'AboutYouForm',

  mixins: [MixinForm],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  watch: {
    data(value) {
      const { photoUrl, ...other } = value
      if (value.photo) {
        readFile(value.photo, event => {
          this.avatarDataUrl = event.target.result
        })
      } else {
        this.avatarDataUrl = photoUrl
      }
      Object.assign({}, this.form, other)
    }
  },

  data() {
    const { photoUrl, nickname, pronoun, facts, photo } = this.data

    if (photo) {
      readFile(photo, event => {
        this.avatarDataUrl = event.target.result
      })
    }

    return {
      form: {
        nickname: nickname,
        pronoun: pronoun,
        facts: facts,
        photo: photo
      },
      avatarDataUrl: photoUrl,
      pronounOptions: PronounOptions
    }
  },

  methods: {
    onAvatarClick() {
      this.$refs.avatarUpload.click()
    },

    onAvatarSelect({ target }) {
      readFile(target.files[0], event => {
        this.avatarDataUrl = event.target.result
      })
      this.form.photo = target.files[0]
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.nickname || '')) errors.nickname = ["Nickname can't be blank"]
      if (!data.pronoun) errors.pronoun = ["Pronoun can't be blank"]
      if (Object.values(PRONOUN_TYPE).indexOf(data.pronoun) === -1) errors.pronoun = ['Invalid pronoun']
      return errors
    }
  },

  components: {
    BIconInfoCircle,
    DefaultAvatar
  }
}
</script>
